<!-- Blog -->
<div class="blog-area ptb-80">
  <div class="container">
    <div class="section-title">
      <span class="sub-title">Blog</span>
      <h3 i18n="@@ourLatestArticlesTitle">Our Latest Articles</h3>
      <div class="bar"></div>
      <p i18n="@@ourLatestArticlesSubtitle">
        News, tips, training, management notes, interviews of interest and much more
      </p>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-6" *ngFor="let article of latestContent; index as i">
        <div class="single-blog-post-item">
          <div class="post-image">
            <a [routerLink]="'/blog/' + article.contentSlug"><img [src]="article.featureImageUrl" alt="image" /></a>
          </div>
          <div class="post-content">
            <div class="post-meta">
              <ul>
                <li>
                  <a href="javascript:void(0)">{{ article.authorName }}</a>
                </li>
                <li>{{ article.contentPublishDate | date: 'dd MMM yyyy' }}</li>
              </ul>
              <h3>
                <a [routerLink]="'/blog/' + article.contentSlug">{{ article.contentTitle | shorten: 55:'...' }}</a>
              </h3>
              <a [routerLink]="'/blog/' + article.contentSlug" class="learn-more-btn">
                <span i18n="@@readBlogStory">Read Story</span> <i-feather name="plus-circle"></i-feather
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
